import type { ArrItemBase } from '../workers/utils'
import type { ArrItemWithMetric } from '../workers/aggregate-bridge.worker'

export const isArrItemWithMetric = (
  item: ArrItemBase,
): item is ArrItemWithMetric =>
  typeof (item as ArrItemWithMetric)?.metric === 'string'
